module.exports = __webpack_public_path__ + "static/media/Hang.225cc857.png";